/**
 * D29 (mig 796) — a pesquisa de satisfação pendente, no Início do Portal. Sem pesquisa pendente (ou com a pesquisa
 * desligada), nada aparece. A primeira resposta (aqui ou pelo link) fecha.
 */
import { useEffect, useState } from 'react';

import { Button } from '@/components/ui';
import { clienteApi } from '@/lib/cliente-api';

interface Pendente {
  id: string;
  osNumero: number;
  data: string;
  perguntaNota: string;
  perguntaComentario: string;
}

export function PesquisaNoPortal() {
  const [lista, setLista] = useState<Pendente[]>([]);
  const [nota, setNota] = useState<number | null>(null);
  const [comentario, setComentario] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [feito, setFeito] = useState(false);

  useEffect(() => {
    let vivo = true;
    Promise.resolve()
      .then(() => clienteApi.get<{ pesquisas: Pendente[] }>('/pesquisas'))
      .then((r) => vivo && setLista(r?.pesquisas ?? []))
      .catch(() => vivo && setLista([]));
    return () => {
      vivo = false;
    };
  }, []);

  const p = lista[0];
  if (feito) {
    return (
      <p className="rounded-xl border border-line bg-paper-surface p-4 text-sm font-semibold" role="status">
        Obrigado! A sua resposta chegou à equipe da IGM.
      </p>
    );
  }
  if (!p) return null;

  async function enviar() {
    if (nota === null) return setErro('Escolha uma nota de 0 a 10.');
    setErro(null);
    try {
      await clienteApi.post(`/pesquisas/${encodeURIComponent(p.id)}/responder`, { nota, comentario });
      setFeito(true);
    } catch {
      setErro('Não deu para enviar agora. Tente de novo.');
    }
  }

  return (
    <section className="flex flex-col gap-3 rounded-xl border border-line bg-paper-surface p-4 dark:border-line-dark dark:bg-paper-dark-surface" data-testid="pesquisa-no-portal">
      <h2 className="text-base font-semibold">Como foi o atendimento da OS #{p.osNumero}, de {p.data}?</h2>
      <fieldset>
        <legend className="mb-2 text-sm">{p.perguntaNota}</legend>
        <div className="grid grid-cols-6 gap-2 sm:grid-cols-11">
          {Array.from({ length: 11 }, (_, n) => (
            <button
              key={n}
              type="button"
              aria-pressed={nota === n}
              onClick={() => setNota(n)}
              className={`min-h-[44px] rounded-lg border text-sm font-semibold ${nota === n ? 'border-red bg-red text-white' : 'border-line bg-paper-surface text-ink-1 dark:border-line-dark dark:bg-paper-dark-surface dark:text-ink-dark-1'}`}
            >
              {n}
            </button>
          ))}
        </div>
      </fieldset>
      <label htmlFor="pes-portal-coment" className="text-sm">
        {p.perguntaComentario}
      </label>
      <textarea
        id="pes-portal-coment"
        rows={3}
        maxLength={2000}
        value={comentario}
        onChange={(e) => setComentario(e.target.value)}
        className="w-full rounded-xl border border-line bg-paper-surface px-3 py-2 text-sm dark:border-line-dark dark:bg-paper-dark-elevated"
      />
      {erro ? (
        <p role="alert" className="text-sm font-semibold text-red-deep dark:text-red-glow">
          {erro}
        </p>
      ) : null}
      <Button onClick={() => void enviar()} className="min-h-[44px] self-start">
        Enviar resposta
      </Button>
    </section>
  );
}
